import React, { Component, PropTypes } from 'react';
import { SubmissionError } from 'redux-form';
import ModalDialog from 'common/components/modal/modal_dialog';
import RequestPaymentForm from 'account/components/payout/request_payment_form';
import Money from 'common/components/money';
import { sumAwards, getNextPaymentDate } from 'common/ducks/payout';

const INITIAL_VALUES = { awards: [] };

/**
 * Request payment modal.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class RequestPaymentModal extends Component {
  constructor(props) {
    super(props);

    this.state = { totalRequested: null };

    this.handleDone = this.handleDone.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDone() {
    const { onClose, fetchRequested, fetchPendingAwards } = this.props;

    /* fetch updated list of requested payments */
    fetchRequested();
    /* fetch updated list of pending awards */
    fetchPendingAwards();

    onClose();
  }

  handleSubmit(data) {
    const total = sumAwards(data.awards);
    const { user, requestPaymentRequest } = this.props;

    return requestPaymentRequest(user.id, data.awards)
      .then(() => this.setState({ totalRequested: total}))
      .catch((res) => {
        /* field-specific errors */
        const data = res.data;
        if (data) {
          for (const field of Object.keys(data)) {
            if (data[field]) throw new SubmissionError({ [field]: data[field][0] });
          }
        }
        /* global error */
        throw new SubmissionError({ _error: 'Unknown error. Please try again.' });
      });
  }

  renderContent() {
    const { onClose, account } = this.props;
    const { totalRequested } = this.state;

    /* don't allow requests if there's no default account or it's not ready */
    if (!account || (account.system == 'payoneer' && account.status !== 'enabled')) {
      return (
        <div className="done">
          <h3>{account ? "Default account not enabled" : "No default account defined"}</h3>
          <p>
            {account?
            "Your default account hasn't been enabled yet, so you can't create requests for it." :
            "You don't have any default account defined, so you can't create requests yet."}
          </p>
          <div className="modal-actions">
            <button className="btn btn-primary" onClick={onClose}>Done</button>
          </div>
        </div>);
    }

    if (totalRequested) {
      return (
        <div className="done">
          <h1><i className="fa fa-check-circle text-success"/> Payment Scheduled</h1>

          <div className="total">
            <h5>Total Payment</h5>
            <h2><Money value={totalRequested}/></h2>
            <p>
              Your payment is scheduled and should post to
              your<br className="hide-for-small-only"/> account within the next 10 business days.
            </p>
          </div>

          <div className="modal-actions">
            <button className="btn btn-primary" onClick={this.handleDone}>Done</button>
          </div>
        </div>);
    }

    return (
      <RequestPaymentForm onSubmit={this.handleSubmit} initialValues={INITIAL_VALUES}
                          onCancel={onClose} />);

  }

  render() {
    const { onClose } = this.props;

    return (
      <ModalDialog modalOpen={true} dialogClasses="request-payment-modal" closeAction={onClose}>
        { this.renderContent() }
      </ModalDialog>);
  }
};

/**
 * PropTypes.
 *
 * @property {object} user - logged in user
 * @property {object} account - account related to this request
 * @property {func} onClose - on close callback
 * @property {func} requestPaymentRequest - ajax request to request payment
 * @property {func} fetchRequested - fetch requested payments
 * @property {func} fetchPendingAwards - fetch pending awards
 */
RequestPaymentModal.propTypes = {
  user: PropTypes.object,
  account: PropTypes.object,
  onClose: PropTypes.func,
  requestPaymentRequest: PropTypes.func,
  fetchRequested: PropTypes.func,
  fetchPendingAwards: PropTypes.func
};



// WEBPACK FOOTER //
// ./account/components/payout/request_payment_modal.jsx